import {BackendLocationModel} from './location.model';

export class ObservationModel {
  readonly id: number;
  readonly timestamp: string;
  readonly expiration: string;
  readonly description: string|null;
  readonly comment: string|null;
  readonly typeId: number;
  readonly shiftId: number;
  readonly driverId: number;
  readonly vehicleId: number;
  readonly location: BackendLocationModel;
  readonly imageUrl: string|null;
}

export class ObservationTypeModel {
  readonly id: number;
  readonly title: string;
  readonly color: string;
  readonly order: number;
  readonly abbreviation: string;
  readonly observationTypeGroupId: number;
}

export class NewObservation {
  timestamp: Date|null;
  observationTypeId: number;
  description: string;
  location: BackendLocationModel;
  comment: string;
}
